import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "logo" }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  class: "main-button-container",
  ref: "refreshIconRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background bad-connection-page",
        fullscreen: true,
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.logoSrc,
              alt: "liga-logo"
            }, null, 8, _hoisted_2)
          ]),
          _createVNode(_component_ion_card, { class: "bad-connection-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, { class: "ion-text-center bad-connection-title" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("ОТСУТСТВУЕТ СОЕДИНЕНИЕ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reconnect())),
                      disabled: _ctx.reconnecting
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.refreshOutline
                        }, null, 8, ["icon"]), [
                          [_vShow, !_ctx.reconnecting]
                        ]),
                        _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                          [_vShow, _ctx.reconnecting]
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (_ctx.isMobile)
                      ? (_openBlock(), _createBlock(_component_ion_button, {
                          key: 0,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setOfflineMode())),
                          class: "offline-button"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode(" ОФФЛАЙН ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 512)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}